import { uiNeutrals } from "./uiNeutrals";

/**
 * Standard close (×) control: rounded rect on surface.
 * Use on MUI `IconButton` via `sx={{ ...closeIconButtonSx }}` (merge overrides as needed).
 */
export const closeIconButtonSx = {
  flexShrink: 0,
  bgcolor: uiNeutrals.surface,
  borderRadius: "10px",
  p: 0.65,
  mr: 0.1,
  color: "#000",
  "&:hover": { bgcolor: uiNeutrals.surfaceHover },
  "& .MuiSvgIcon-root": { fontSize: 20 },
};

/** Same surface treatment, slightly tighter for inline clears (e.g. search field). */
export const closeIconButtonDenseSx = {
  ...closeIconButtonSx,
  p: 0.45,
  mr: 0,
  "& .MuiSvgIcon-root": { fontSize: 18 },
};
